import React from 'react'

const LoadingComponent = () => {
  return (
    <div className='loaderContainer'>
      <div className="outerCircle">
        <div className="middleCircle">
          <div className="innerCircle" />
        </div>
      </div>
    </div>
  )
}

export default LoadingComponent